import type {
  CreateCheckoutLeadBody,
  CreateCheckoutLeadResponse,
} from "@nlc/shared-types";

import { unauthenticatedApi } from "@/lib/api/client";

export async function createCheckoutLead(
  data: CreateCheckoutLeadBody,
): Promise<CreateCheckoutLeadResponse> {
  return unauthenticatedApi
    .url("/checkout-leads")
    .post(data)
    .json<CreateCheckoutLeadResponse>();
}

export async function updateCheckoutLeadEmail(
  id: string,
  email: string,
): Promise<void> {
  await unauthenticatedApi.url(`/checkout-leads/${id}`).patch({ email }).res();
}

export async function convertCheckoutLead(id: string): Promise<void> {
  await unauthenticatedApi.url(`/checkout-leads/${id}/convert`).post().res();
}
